import { API_URL } from "../App";

export const apiRequestHeader = async (
  endpoint,
  method = "GET",
  body = null,
  customHeaders = {}
) => {
  const response = await fetch(`${API_URL}/${endpoint}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...customHeaders,
    },
    body: body ? JSON.stringify(body) : null,
  });
  return await response.json();
};
